export default {
  getInterviewPolicies(state) {
    return state.interviewPolicies;
  },
  getAllDifferentPolicies(state) {
    return state.allDifferentPolicies;
  },
};
